module.exports = __webpack_public_path__ + "static/media/communicationIcon.59c09612.jpg";